export enum DatabaseProviderType {
    SQLServer = 1,
    Oracle =  2,
    Postgres = 3,
    MySQL = 4
}
